module.exports = __webpack_public_path__ + "img/image_2.1aaf76c0.jpg";